import header from "../images/skillAssessment/skillHeader.png";

import {
  FaPencilRuler,
  FaPalette,
  FaTheaterMasks,
  FaBuilding,
  FaHandshake,
  FaChalkboardTeacher,
  FaMicroscope,
  FaRunning,
  FaUserMd,
  FaHotel,
  FaBullhorn,
  FaNewspaper,
  FaCogs,
  FaLaptopCode,
  FaUsers,
  FaCalculator,
  FaTruckLoading,
  FaUserShield,
  FaBalanceScale,
} from "react-icons/fa";

const SkillAssessment = () => {
  const skillData = [
    {
      title: "Design or Architecture Engineering",
      desc: "Shape the world through creativity and structural innovation.",
      icon: <FaPencilRuler />,
    },
    {
      title: "Creative, Fine Arts & Visual Arts Professional",
      desc: "Turn imagination into impactful expressions.",
      icon: <FaPalette />,
    },
    {
      title: "Acting, Music, Dance & Performing Artists",
      desc: "Entertain, inspire, and influence through performance.",
      icon: <FaTheaterMasks />,
    },
    {
      title: "Managers, General Admin & Civil Servants",
      desc: "Lead, organize, and contribute to public service or private sector operations.",
      icon: <FaBuilding />,
    },
    {
      title: "Sales & Relationship Managers",
      desc: "Build connections and drive growth with strategic communication.",
      icon: <FaHandshake />,
    },
    {
      title: "Educator, Teacher & Counselor",
      desc: "Empower the future through knowledge, guidance, and mentorship.",
      icon: <FaChalkboardTeacher />,
    },
    {
      title: "Advanced Science or Engineering",
      desc: "Innovate with cutting-edge technology and deep research.",
      icon: <FaMicroscope />,
    },
    {
      title: "Sports, Fitness & Administration",
      desc: "Champion wellness and sports excellence.",
      icon: <FaRunning />,
    },
    {
      title: "Medicine, Health Science & Medical Admin",
      desc: "Care, cure, and lead in healthcare services.",
      icon: <FaUserMd />,
    },
    {
      title: "Hospitality, Travel & Hotel Managers",
      desc: "Create memorable experiences across the globe.",
      icon: <FaHotel />,
    },
    {
      title: "Advertising & Marketing Professionals",
      desc: "Shape brand stories and customer engagement.",
      icon: <FaBullhorn />,
    },
    {
      title: "Media, Journalists, Event Mgmt, Learning Dev",
      desc: "Inform, engage, and inspire with communication and creativity.",
      icon: <FaNewspaper />,
    },
    {
      title: "Operations, Planning, Service Manager",
      desc: "Drive efficiency and process excellence.",
      icon: <FaCogs />,
    },
    {
      title: "Computer & IT Professionals",
      desc: "Build the digital future through code, systems, and innovation.",
      icon: <FaLaptopCode />,
    },
    {
      title: "Human Resource, Counseling & Training",
      desc: "Support people, shape culture, and enhance growth.",
      icon: <FaUsers />,
    },
    {
      title: "Finance & Accounting Professionals",
      desc: "Manage money, strategy, and financial planning.",
      icon: <FaCalculator />,
    },
    {
      title: "Supply Chain & Distribution, Purchase",
      desc: "Optimize flow and logistics in businesses.",
      icon: <FaTruckLoading />,
    },
    {
      title: "Police Services & Armed Forces Officers",
      desc: "Serve, protect, and lead with integrity and courage.",
      icon: <FaUserShield />,
    },
    {
      title: "Lawyers & Judiciary Services Professionals",
      desc: "Uphold justice and advocate for the rule of law.",
      icon: <FaBalanceScale />,
    },
  ];

  return (
    <div className="skillAssessment">
      <div className="header">
        <div className="container">
          <h1>Skill Assessment</h1>
          <h2>
            Discover your strengths. <br />
            <b>Unlock your potential.</b>
          </h2>
          <p>
            Uncover what makes you unique through our{" "}
            <span>AI-powered skill assessment</span>. We help you identify your
            core capabilities, interests, and growth areas — guiding you to the
            most suitable career path with confidence and clarity.
          </p>
        </div>
        <img src={header} alt="Study Abroad Header" className="headerImage" />
      </div>
      <div className="skillWrapper">
        <div className="container">
          <div className="skillDesc">
            <h2>
              Discover your <b>Potential.</b>
            </h2>
            <p className="mdText">
              Short, effective skill assessments to guide your career journey.
            </p>
          </div>
          <div className="skillList">
            {skillData.map((skill, index) => (
              <div className="skillItem" key={`skill-${index}`}>
                <div className="img">{skill.icon}</div>
                <div className="skillInfo">
                  <h5>{skill.title}</h5>
                  <p className="mdText">{skill.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-center">
            <div className="skillBanner">
              <h3>Ready to take the next step?</h3>
              <p className="mdText">
                Begin your personalized skill assessment and unlock the path to
                your ideal career.
              </p>
              <a href="/contact" class="button yellow-button">
                Start Your Assessment Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillAssessment;
